import React from 'react';
import {
  PageTitle,
  CompanyStatus,
  AccordionToggle,
} from '../components/LaborSafetyComponents';
import { buttonWrapper } from '../utilities/LaborSafetyNotify';
import _slideLoader from '../utilities/slideLoader';

/**
 * @description 施工体系台帳 詳細ページコンポーネント
 */
export const WorkLedgerDetail = ({ vw }) => (
  <div className='master-slide-view show'>
    <div className='master-slide-view__view'>
      <div className='setting-main'>
        <div
          className='labor-safety-main__header labor-safety-constsys-ledger-notify__header'
          style={{ pointerEvents: 'all' }}
        >
          <PageTitle title='施工体系台帳 - {company_name}' />
          <button
            className='labor-safety-main__btn'
            onClick={() => _slideLoader.close(vw)}
          >
            <i className='i-close i-3x' />
          </button>
        </div>
        <Header vw={vw} />
        <div className='labor-safety-body labor-safety-constsys-ledger-notify-body' />
      </div>
    </div>
  </div>
);

/**
 * @description 設定ヘッダーメニュー
 */
const Header = ({ vw }) => (
  <div
    id='labor-safety-header'
    className='labor-safety-header labor-safety-constsys-ledger-notify-header'
  >
    <HeaderButtons />
    <CompanyStatus vw={vw} />
  </div>
);

const HeaderButtons = buttonWrapper(
  ({ onExcel, onPDF, onApproval, onCansel }) => (
    <div className='labor-safety-header__item labor-safety-constsys-ledger-notify-header__item'>
      <ul className='btn-menu labor-safety-constsys-ledger-notify__header-buttons'>
        <li className='btn-menu__item'>
          <button className='btn' onClick={onExcel}>
            Excelで出力
          </button>
        </li>

        <li className='btn-menu__item'>
          <button className='btn' onClick={onPDF}>
            PDFで出力
          </button>
        </li>

        <li className='btn-menu__item'>
          <button className='btn--effective' onClick={onApproval}>
            承認する
          </button>
        </li>

        <li className='btn-menu__item'>
          <button className='btn--negative' onClick={onCansel}>
            否認する
          </button>
        </li>
        <AccordionToggle />
      </ul>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/pages/WorkLedgerDetail.jsx